
type StorageType = 'LOCAL' | 'SESSION'

const typeDefault: StorageType = 'LOCAL'

const get = (key: string, type: StorageType = typeDefault) => {
  const lsData = (type === typeDefault ? localStorage : sessionStorage).getItem(key)
  return (lsData ?  JSON.parse(lsData) : lsData)
}

const set = (key: string, value: any, type: StorageType = typeDefault) => {
  (type === typeDefault ? localStorage : sessionStorage).setItem(key, (value ? JSON.stringify(value) : value))
}

const remove = (key: string, type: StorageType = typeDefault) => {
  (type === typeDefault ? localStorage : sessionStorage).removeItem(key)
}

const storage = {
  get,
  set,
  remove
}

export { storage }